module.exports = __webpack_public_path__ + "img/qrcode.6a2cc64e.svg";